import { render } from "./Bookings.vue?vue&type=template&id=64b61a36"
import script from "./Bookings.vue?vue&type=script&lang=js"
export * from "./Bookings.vue?vue&type=script&lang=js"

import "./Bookings.vue?vue&type=style&index=0&id=64b61a36&lang=css"

import exportComponent from "/codebuild/output/src429286328/src/application/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__